import React, { Component } from 'react'
import apiService from '../../services/ApiService'
import Select from 'react-select'

class Workstation extends Component {
    constructor() {
        super()
        this.state = {
            workstationList: "",
        }
        this.isComponentStillMounted = true
    }

    componentDidMount() {
        this.getWorkstationList(this.props.type)
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    getWorkstationList = (type) => {
        apiService.getWorkstationDetailList(type)
            .then(listData => {
                if (listData && this.isComponentStillMounted) {
                     this.setState({
                        workstationList: listData.data
                    })
                    
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
            })
    }

    render() {
        let list = {}
        list = Object.keys(this.state.workstationList).map((value,index) => {
            
            return {
                label : this.state.workstationList[value],
                value : value,
            }
        })
        list.sort((a,b) => a.label.localeCompare(b.label));

        return (
            <div>
                <Select
                value={this.props.selectedValue}
                placeholder="Select Workstation"
                options={list}
                onChange={(e) => { (e) ? this.props.workstationChange(e) : this.props.workstationChange([])}}
                />
            </div>
        )
    }
}
export default Workstation


// WEBPACK FOOTER //
// ./src/common/DropDowns/Workstation.js